import { ProgressCircleManySegments } from "@/components/ui/charts/progress-circle-many-segments";
import { getDimensionById } from "@/lib/dimensions";
import { cn } from "@/lib/utils";
import { HighlightedTopic } from "@/requests/reports/performance-detail-report.request";
import { FC, HTMLAttributes } from "react";

type RelevantsTopicsCardTopicProps = HTMLAttributes<HTMLDivElement> & {
  topic: HighlightedTopic;
};

const RelevantsTopicsCardTopic: FC<RelevantsTopicsCardTopicProps> = ({
  className,
  topic,
  ...props
}) => {
  const dimension = getDimensionById(topic.topic.dimension.dimension);

  return (
    <div className={cn(className, "flex flex-col items-center")} {...props}>
      <ProgressCircleManySegments
        radius={60}
        strokeWidth={15}
        segments={[
          {
            color: "#F1F4F9",
            value: 100 - topic.result.scorePercentage,
          },
          {
            color: "#6CDA96",
            value: topic.result.scorePercentage,
          },
        ]}
      >
        <p className="text-sm font-semibold text-black">
          <span className="block">
            {topic.result.score}/{topic.result.scoreProportion}
          </span>
          <span className="block">puntos</span>
        </p>
      </ProgressCircleManySegments>

      <p className="my-3 grow text-center text-lg text-black">
        {topic.topic.name}
      </p>

      {dimension && (
        <div className="flex items-center gap-2">
          <div
            className="flex h-8 w-8 items-center justify-center rounded-full"
            style={{ backgroundColor: dimension.color }}
          >
            <dimension.icon className="text-white" size={16} />
          </div>
          <p className="flex-1 text-sm">{topic.topic.dimension.name}</p>
        </div>
      )}
    </div>
  );
};

export default RelevantsTopicsCardTopic;
